var render, staticRenderFns
import script from "./plugin-drop.vue?vue&type=script&lang=js"
export * from "./plugin-drop.vue?vue&type=script&lang=js"
import style0 from "./plugin-drop.vue?vue&type=style&index=0&id=055c1dbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c1dbf",
  null
  
)

export default component.exports